import { axios } from "../../lib/axios";

export const DeleteBook = (bookId: string) => {
    return axios.delete(`/book/${bookId}`)
        .then(response => response.data);
};